import * as PropTypes from 'prop-types';
import React from 'react';
import Button from './button';

const ValidationAlertMessage = props => {
   return <>
      <div key={`${props.linkText}-key`}>
         <Button
            color={'blue'}
            displayAs={'link'}
            onClick={() => props.fieldReference.focus()}
            style={{padding: 0}}
            analyticsDescription={'focus field'}
         >
            {props.linkText}
         </Button>: {props.description}
      </div>
   </>
};

ValidationAlertMessage.propTypes = {
   description: PropTypes.string.isRequired,
   fieldReference: PropTypes.object.isRequired,
   linkText: PropTypes.string.isRequired,
};

export default ValidationAlertMessage;